import { stripSignature } from './mailCompose'
import type { ComposeState } from './mailTypes'

export function composeHasContent(c: ComposeState): boolean {
  if (c.to.trim() || c.cc.trim() || c.bcc.trim() || c.subject.trim()) return true
  if ((c.attachments?.length ?? 0) > 0) return true
  const body = stripSignature(c.body)
    .replace(/<[^>]+>/g, '')
    .replace(/&nbsp;/g, ' ')
    .trim()
  return body.length > 0
}
